// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .bdt-card-box>.card {}

.bdt-card-box>.card>.card-body {
    padding: 5px !important;
} */

.Filter_RangeAnalysis_bdt_card_box__FKeYO>.Filter_RangeAnalysis_card__2q7FA {}

.Filter_RangeAnalysis_bdt_card_box__FKeYO>.Filter_RangeAnalysis_card__2q7FA>.Filter_RangeAnalysis_card-body__lSgVI {
    padding: 5px !important;
}

/* .small-bdt {
    font-size: 80% !important;
} */

.Filter_RangeAnalysis_small_bdt__8K-Tr {
    font-size: 80% !important;
}

.Filter_RangeAnalysis_filter_bus_icon_bdt__Pqr25 .Filter_RangeAnalysis_rca_btn__bfbYV .Filter_RangeAnalysis_rca_btn_bus__KazH8 {
    background-color: #ffa650;
}

.Filter_RangeAnalysis_filter_bus_icon_bdt__Pqr25 .Filter_RangeAnalysis_rca_btn__bfbYV .Filter_RangeAnalysis_rca_btn_bus__KazH8:hover {
    background-color: #fcb877 !important;
    border-color: #fcb877 !important;
}

/* .top-filter-bdt {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
} */

.Filter_RangeAnalysis_top_filter_bdt__6TCbn {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
}


.Filter_RangeAnalysis_btn_bus_bdt__935jM {
    background-color: #83A4CF !important;
}

.Filter_RangeAnalysis_bus_filtr_btn_bdt__AEffK {
    position: relative;
    top: 10px;
}

.Filter_RangeAnalysis_date_range_selection__o\\+1c5 {
    color: #364e69;
    font-Weight: bold;
}

.Filter_RangeAnalysis_filter_dropdown__R6JtA {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding-top: 7px;
    padding-bottom: 7px;

}

.Filter_RangeAnalysis_customDateRangePicker__yzbC\\+ {
    font-size: small;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/RangeAnalysisTab_bus/Filter_RangeAnalysis/Filter_RangeAnalysis.module.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH,6EAAqB;;AAErB;IACI,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* .bdt-card-box>.card {}\n\n.bdt-card-box>.card>.card-body {\n    padding: 5px !important;\n} */\n\n.bdt_card_box>.card {}\n\n.bdt_card_box>.card>.card-body {\n    padding: 5px !important;\n}\n\n/* .small-bdt {\n    font-size: 80% !important;\n} */\n\n.small_bdt {\n    font-size: 80% !important;\n}\n\n.filter_bus_icon_bdt .rca_btn .rca_btn_bus {\n    background-color: #ffa650;\n}\n\n.filter_bus_icon_bdt .rca_btn .rca_btn_bus:hover {\n    background-color: #fcb877 !important;\n    border-color: #fcb877 !important;\n}\n\n/* .top-filter-bdt {\n    width: 100%;\n    background: #fff;\n    height: 35px;\n    border: solid 1px #a5a5a5;\n    border-radius: 3px;\n    font-size: 14px;\n    color: #353535;\n    text-indent: 10px;\n    margin-bottom: 12px;\n} */\n\n.top_filter_bdt {\n    width: 100%;\n    background: #fff;\n    height: 35px;\n    border: solid 1px #a5a5a5;\n    border-radius: 3px;\n    font-size: 14px;\n    color: #353535;\n    text-indent: 10px;\n    margin-bottom: 12px;\n}\n\n\n.btn_bus_bdt {\n    background-color: #83A4CF !important;\n}\n\n.bus_filtr_btn_bdt {\n    position: relative;\n    top: 10px;\n}\n\n.date_range_selection {\n    color: #364e69;\n    font-Weight: bold;\n}\n\n.filter_dropdown {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n\n}\n\n.customDateRangePicker {\n    font-size: small;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bdt_card_box": `Filter_RangeAnalysis_bdt_card_box__FKeYO`,
	"card": `Filter_RangeAnalysis_card__2q7FA`,
	"card-body": `Filter_RangeAnalysis_card-body__lSgVI`,
	"small_bdt": `Filter_RangeAnalysis_small_bdt__8K-Tr`,
	"filter_bus_icon_bdt": `Filter_RangeAnalysis_filter_bus_icon_bdt__Pqr25`,
	"rca_btn": `Filter_RangeAnalysis_rca_btn__bfbYV`,
	"rca_btn_bus": `Filter_RangeAnalysis_rca_btn_bus__KazH8`,
	"top_filter_bdt": `Filter_RangeAnalysis_top_filter_bdt__6TCbn`,
	"btn_bus_bdt": `Filter_RangeAnalysis_btn_bus_bdt__935jM`,
	"bus_filtr_btn_bdt": `Filter_RangeAnalysis_bus_filtr_btn_bdt__AEffK`,
	"date_range_selection": `Filter_RangeAnalysis_date_range_selection__o+1c5`,
	"filter_dropdown": `Filter_RangeAnalysis_filter_dropdown__R6JtA`,
	"customDateRangePicker": `Filter_RangeAnalysis_customDateRangePicker__yzbC+`
};
export default ___CSS_LOADER_EXPORT___;
